window.InformacaoController = ControllerBase.extend({
    name: "InformacaoController",

    initialize: function() {
        this.atacharEventos();
        $("button[name=btnOk]").focus();
    },

    atacharEventos: function() {
        $("#btnOk").bind("click", $.proxy(this.atualizarOidFilial, this));
        //$("select[name=OidFilial]").change($.proxy(this.oidFilialAterada, this));
        $("input").on('focus', function () { $(this).select(); });
    },

    atualizarOidFilial: function (e) {
        var oidFilial = $("select[name=OidFilial]").val();
        var $btnOk = $("#btnOk");
        $btnOk.enable(false);
        global.ajax({
            url: "/Vendedor/AlterarFilial",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                oidFilial: oidFilial
            }),
            error: function (mensagem) { $btnOk.enable(true); },
            success: function(mensagem) {
                if (mensagem && mensagem.UrlReturn) {
                    window.location.href = decodeURIComponent(mensagem.UrlReturn);
                } else if (mensagem != null && mensagem.length > 0) {
                    global.showErrorMessage(mensagem);
                    $btnOk.enable(true);
                }
            }
        });
    },

});